import { MessagingTemplateTypes } from "@enums/messaging-template-types";

export const MESSAGING_TEMPLATE_TYPE_OPTIONS = [
    {
        label: MessagingTemplateTypes.PIN_EMAIL,
        value: MessagingTemplateTypes.PIN_EMAIL
    },
    {
        label: MessagingTemplateTypes.PIN_SMS,
        value: MessagingTemplateTypes.PIN_SMS
    },
    {
        label: MessagingTemplateTypes.DCUI_EMAIL,
        value: MessagingTemplateTypes.DCUI_EMAIL
    },
    {
        label: MessagingTemplateTypes.DCUI_SMS,
        value: MessagingTemplateTypes.DCUI_SMS
    }
];